export class SnapshotRecipeProposal {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "mode",
            "baseName": "mode",
            "type": "SnapshotRecipeProposalMode",
            "format": ""
        },
        {
            "name": "windowFrom",
            "baseName": "windowFrom",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "windowTo",
            "baseName": "windowTo",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "ignoreFlaggedDeletions",
            "baseName": "ignoreFlaggedDeletions",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SnapshotRecipeProposal.attributeTypeMap;
    }
    constructor() {
    }
}
